import { supabase } from '../lib/supabase';

/**
 * Force refresh the user profile to ensure we have the latest data including role
 */
export const forceRefreshProfile = async () => {
  try {
    // Get current user
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) {
      console.log('No user logged in');
      return null;
    }
    
    // Force fetch fresh profile data
    const { data: profile, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', user.id)
      .single();
    
    if (error) {
      console.error('Error fetching profile:', error);
      return null;
    }
    
    console.log('Fresh profile data:', profile);
    console.log('Profile role:', profile.role);
    
    // Force a page reload to update React state
    if (profile.role === 'admin' || profile.role === 'super_admin') {
      console.log('Admin role confirmed, reloading page...');
      window.location.reload();
    }
    
    return profile;
  } catch (error) {
    console.error('Error in forceRefreshProfile:', error);
    return null;
  }
};

// Add to window for easy access in console
if (typeof window !== 'undefined') {
  (window as any).forceRefreshProfile = forceRefreshProfile;
}
